import { TextField, Typography, makeStyles } from "@material-ui/core";
import React from "react";

const useStyles = makeStyles(() => ({
  textfield: {
    flexShrink: 0,
    borderRadius: "8px",
    background: "#FFF",
    "& .MuiOutlinedInput-root": {
      flexShrink: 0,
      borderRadius: "8px",
      "& .MuiInputBase-input": {
        fontSize: "12px",
        paddingTop: "14px",
      },
    },
  },
  inputLabel: {
    color: "#86909F",
    fontSize: "14px",
    fontStyle: "normal",
    fontWeight: 500,
    lineHeight: "18px",
  },
}));

type CustomInputProps = {
  handleChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
  helperText?: any;
  error?: any;
  value?: string;
  placeholder: string;
  isRequired?: boolean;
  label?: string;
  name?: string;
  type?: string;
  rows?: any;
  disabled?: any;
  InputProps?: any;
  startIcon?: React.ReactNode;
  onFocus?: (event: React.FocusEvent<HTMLInputElement>) => void;
  onBlur?: (event: React.FocusEvent<HTMLInputElement>) => void;
};

export default function CustomInput({
  handleChange,
  helperText,
  error,
  value,
  placeholder,
  isRequired,
  label,
  name,
  type,
  rows,
  disabled,
  InputProps,
  startIcon,
  onFocus,
  onBlur,
}: CustomInputProps) {
  const classes = useStyles();

  return (
    <div>
      {label && <Typography variant="font15">{label}</Typography>}

      <TextField
        error={isRequired && error}
        helperText={isRequired && helperText}
        fullWidth
        placeholder={placeholder}
        name={name}
        onChange={handleChange}
        onFocus={onFocus}
        onBlur={onBlur}
        value={value}
        type={type ?? "text"}
        variant="outlined"
        size="small"
        rows={rows}
        disabled={disabled}
        InputProps={{
          ...InputProps,
          startAdornment: startIcon,
          sx: {
            outline: "none",
            "&::placeholder": {
              color: isRequired && error ? "#d32f2f" : "#86909F",
            },
          },
        }}
        sx={{
          mt: "5px",
          "& .MuiOutlinedInput-root": {
            height: rows ? "" : "40px",
            border: isRequired && error ? "1px solid #f44336" : "1px solid #EFEFF0",
            background: "#FBFBFB",
            "&:hover": {
              borderColor: isRequired && error ? "#d32f2f" : "#BDBDBD",
            },
          },
          "& .MuiInputBase-input": {
            color: isRequired && error ? "#d32f2f" : "#415A7C",
            "&::placeholder": {
              color: isRequired && error ? "#f44336" : "#415A7C",
            },
          },
          "& .MuiFormHelperText-root": {
            color: isRequired && error ? "#f44336" : "#415A7C",
          },
        }}
        className={`field_error ${classes.textfield}`}
        InputLabelProps={{
          className: classes.inputLabel,
          sx: {
            color: isRequired && error ? "#d32f2f" : "#415A7C",
          },
        }}
      />
    </div>
  );
}
